import "./App.css";
import Layout from "./layout/layout";
import AlertUI from "./ui/alertUI";

function App() {
    return (
        <>
            <Layout />
            <AlertUI />
        </>
    );
}

export default App;
